import { IGetEmployeeCTCByCodeRequestType, IGetEmployeeInfoByCodeType, IGetEmployeeSalarySheetType } from "./type"

const payrollBaseUrl = "/employee/salary"
export const PayRollEndpointConst = {
    getEmployeeSalaryListUrl: `${payrollBaseUrl}/list`,
    getTraineeSalaryListUrl: `${payrollBaseUrl}/trainee/list`,
    generateSalaryUrl: `${payrollBaseUrl}/generate`,
    deleteSalaryUrl: `${payrollBaseUrl}`,
    updateSalaryStatusUrl: `${payrollBaseUrl}`,
    getSalaryDetails: `${payrollBaseUrl}/details`,
    getSalaryLWPUrl: `${payrollBaseUrl}/leave-witout-pay`,
    getSalaryOverTimeUrl: `${payrollBaseUrl}/overtime`,
    getPartlyDetailsUrl: `${payrollBaseUrl}/partly/details`,
    checkSalaryExists: `${payrollBaseUrl}/exists`,
    holdSalaryUrl: `${payrollBaseUrl}/hold`,
    holdSalaryEmployeesUrl: `${payrollBaseUrl}/hold/list`,
    getHoldSalaryHistoryUrl: `${payrollBaseUrl}/hold/history`,
    deleteHoldSalaryUrl: `${payrollBaseUrl}/hold/remove`,
    getEmployeeRemainedSalaryListUrl: `${payrollBaseUrl}/remaining-salaried-employees`,
    getEmployeeSalaryCertificateUrl: `${payrollBaseUrl}/certificate`,
    updateEmployeeCTCcalculationUrl: `${payrollBaseUrl}/ctc-matrix`,
    getEmployeeDesignationUrl: `${payrollBaseUrl}/designation-types`,
}

export const getEmployeeInfoByCodeUrl = (param: IGetEmployeeInfoByCodeType) => {
    return `${payrollBaseUrl}/${param.employeeCode}/information`
}

export const getSalaryYearUrl = (param: IGetEmployeeInfoByCodeType) => {
    return `${payrollBaseUrl}/${param.employeeCode}/years`
}

export const getSalarySheetUrl = (param: IGetEmployeeSalarySheetType) => {
    return `${payrollBaseUrl}/sheet?month=${param.month}&year=${param.year}&employeeIds=${param.employeeIds}&fileNumber=${param.fileNumber}&onlyTrainee=${param.onlyTrainee}`
}

export const getEmployeeCTCbyCodeUrl = (param: IGetEmployeeCTCByCodeRequestType) => {
    return `${payrollBaseUrl}/${param.employeeCode}/ctc-matrix`
}

export const getEmployeeCTCbyIdUrl = (param: IGetEmployeeCTCByCodeRequestType) => {
    return `${payrollBaseUrl}/${param.contractId}/ctc-matrix`
}

export const validatePreviousContractUrl = (param: IGetEmployeeInfoByCodeType) => {
    return `${payrollBaseUrl}/${param.employeeCode}/validate-previous-contract`
}